import {BiGitRepoForked} from "react-icons/bi";
import {AiFillGithub, AiFillEye} from "react-icons/ai";
import {ImBook} from "react-icons/im";

import Toxicity from "../images/Comment_toxicity.png"
import NBA from "../images/NBA_analytics.png"
import optionsanalyzer from "../images/Options_Analyzer.png"
import azure from "../images/Olypics_data.png"
import Detroit from "../images/Detroit.png"
import rcm from "../images/healthcare_rcm.png"
import relevanseek from "../images/relevanseek.png"
import ipl from "../images/ipl_auction.png"
import fortnite from "../images/fortnite_subreddit.png"

import React from 'react'

const projectConfig = [
    {
        id: "project-10",
        title: "Healthcare RCM Data Pipeline",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Healthcare-Revenue-Cycle-Management",
                icon: <AiFillGithub/>,
            }
        ],
        image: rcm,
        description: "End-to-end Azure data engineering project implementing a robust Medallion architecture (Bronze, Silver, Gold). Utilized Azure Data Factory, Databricks, Data Lake Gen2, and SQL Database to integrate multi-source EMR and claims data. Features include metadata-driven orchestration, SCD Type 2 historical tracking, and star schema modeling.",
        target: "_blank"
    },
    {
        id: "project-9",
        title: "RelevanSeek",
        links: [
            {
                name: "live",
                url: "https://relevanseek.vercel.app/",
                icon: <AiFillEye/>,
            }
        ],
        image: relevanseek,
        description: "AI-powered job networking tool. Engineered a web scraping pipeline using 'staffspy' to extract structured LinkedIn profile data, feeding it directly into a GPT-4o LLM to dynamically evaluate and rank referrers based on specific Job Description requirements.",
        target: "_blank"
    },
    {
        id: "project-5",
        title: "NBA Analytics Using Databricks",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/NBA-Analytics_Databricks_Hackathon",
                icon: <AiFillGithub/>,
            }
        ],
        image: NBA,
        description: "An exceptional End-to-End Data Science project that distinguished itself in the Databricks-organized NBA Analytics Hackathon. Architected a scalable data pipeline to process 100k+ records and predict score margins.", 
        target: "_blank"
    },
    {
        id: "project-7",
        title: "Fortnite Community Analytics",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/INSY670-Fortnite_Reddit_Analysis",
                icon: <AiFillGithub/>,
            }
        ],
        image: fortnite,
        description: "Network analysis of a 550M+ user 'FortniteBR' subreddit. Utilized engagement metrics and centrality measures for influencer identification, and deployed NLP and LDA topic modeling to extract insights on trending game mechanics.",
        target: "_blank"
    },
    {
        id: "project-8",
        title: "IPL Fantasy Auction | Live Bidding Arena",
        links: [
            {
                name: "live",
                url: "https://ipl-auction-website.vercel.app/",
                icon: <AiFillEye/>,
            }
        ],
        image: ipl,
        description: "Interactive web application simulating a live bidding environment. Architected the backend using Supabase real-time tables and WebSockets to stream bids seamlessly across clients with sub-second latency.", 
        target: "_blank"
    },
    {
        id: "project-6",
        title: "Comment Toxicity Analysis",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Comment-Toxicity-Analysis",
                icon: <AiFillGithub/>,
            }
        ],
        image: Toxicity,
        description: "Developed a robust NLP deep learning model using TensorFlow to accurately classify comments based on their toxicity levels.",
        target: "_blank"
    },
    {
        id: "project-4",
        title: "Automated Option Analyzer",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Automated-Options-Analyzer_2021",
                icon: <AiFillGithub/>
            }
        ],
        image: optionsanalyzer,
        description: "The Automated Option Analyzer simplifies stock options analysis using Python and a distinctive color-coding system, aiding investors in making informed decisions.   ",
        target: "_blank"
    },
    {
        id: "project-3",
        title: "Olympics Data Analysis",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Tokyo-Olympics-Data-Analysis-Microsoft-Azure-End-to-End-Pipeline-Project",
                icon: <AiFillGithub/>
            }
        ],
        image: azure,
        description: "This project demonstrates an end-to-end data engineering pipeline for Tokyo Olympics data analysis and visualization using Azure, Databricks and Power BI."
        ,
        target: "_blank"
    }
    ,
    {
        id: "project-2",
        title: "Predicting Blood Donations",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Kaggle-Predicting-Blood-Donations",
                icon: <AiFillGithub/>
            }
        ],
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS625t0uWONwjbexKtO070hMAsnXq7rNI5QXA&usqp=CAU",
        description: "Using Kaggle dataset, built a Logistic Regression model which predicts whether a person would donate blood or not based on their characterstics."
        ,
        target: "_blank"
    }
    ,
    {
        id: "project-1",
        title: "Detroit Blight Ticket Compliance",
        links: [
            {
                name: "repo",
                url: "https://github.com/SherlockkOms/Detroit-Blight-TIcket-Compliance",
                icon: <AiFillGithub/>
            }
        ],
        image: Detroit,
        description: "This project analyzes Detroit's Blight ticket data, preprocesses it, and builds a predictive model using Random Forest to assess ticket compliance."
        ,
        target: "_blank"
    }

]

export default projectConfig
